import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$alias/_app/highlights/')(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  return null
}
